import { render, staticRenderFns } from "./apMsg_ec.vue?vue&type=template&id=6f0e3b15&scoped=true&"
import script from "./apMsg_ec.vue?vue&type=script&lang=js&"
export * from "./apMsg_ec.vue?vue&type=script&lang=js&"
import style0 from "./apMsg_ec.vue?vue&type=style&index=0&id=6f0e3b15&lang=less&scoped=true&"
import style1 from "./apMsg_ec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e3b15",
  null
  
)

component.options.__file = "apMsg_ec.vue"
export default component.exports